import { Config } from "../models/config";

const CONFIG_VALUES = new Config();

export const Constants = {
  CONFIG_VALUES,
  // Header Component Data
  ORDER_EXPRESS: "Order Express",
  WELCOME: "Welcome:",
  HOME: "Home",
  CENTARLIZED_CSOS: "Centralized CSOS Management",
  CSOS_ADMIN: "CSOS Administration >",
  LOGOUT: "Log Out",
  ACCOUNT_SELECTION: "Account Selection",
  CLEAR_FILTER: "Clear Filter",
  DC_ACCOUNT: "DC-ACCOUNT#",
  DC: "DC #",
  ACCOUNT: "ACCOUNT #",
  ACCOUNT_NAME: "ACCOUNT NAME",
  DC_CUTOFF: "Orders by DC Cutoff Time >",
  LOGOUT_URL: "https://orderexpressstg.cardinalhealth.com",
  ACCOUNT_URL: CONFIG_VALUES.accountSelectionURL,
  TIME_ZONE: "EST",
  ORDER_EXPRESS_BUSINESS: "OrderExpress",

  // Footer Component Data
  HELP: "Help",
  PRIVACY_POLICY: "Privacy Policy",
  PRIVACY_POLICY_URL: "http://cardinalhealth.com/us/en/PrivacyPolicy/PrivacyPolicy",
  TERMS_OF_SERVICE: "Terms Of Service",
  TERMS_OF_SERVICE_URL: "http://cardinalhealth.com/us/en/Legal/Legal",
  CARDINAL_HEALTH: "CardinalHealth.com",
  CARDINAL_HEALTH_URL: "http://cardinalhealth.com",
  COPYRIGHT_DATA: "Cardinal Health, Inc, or one of its subsidiaries. All Rights Reserved.",
  MYACCOUNTS_SECTION: "My Account",
  CONTACTS_NUMBER: "1-800-ECOMHLP (326-6457)",
  CONTACTS_SECTION: "Contacts",
  CARDINAL_HEALTH_SECTION: "Cardinal Health",
  REGISTER_CERTIFICATE: "Register Certificate",
  REGISTER_CERTIFICATE_URL: CONFIG_VALUES.registerCertificateURL,

  // Pending Component Data
  PAGE: "Page",
  OF: "Of",
  LIMIT: 100,
  START_PAGE: 1,
  REFRESH: "Refresh",
  FROM_PENDING_PAGE: "PendingSummary",
  FROM_SIGNED_PAGE: "SignedSummary",

  // Order Detail Data
  UTN_ERROR: "UTN must be 6 characters long and not contain special characters.",
  QUANTITY_ERROR: "Please enter a value equal to or lower than the Order QTY. Value cannot be less than 0.",
  TIMER_SECONDS: 900,

  // order detail status code
  REJECTED: "7",
  Locked: "12",
  FAILURE: "10",
  APPROVED: "13",
  INPROGRESS: "14",
  NEW: "11",
  SIGNED: "1",
  CANCEL: "16",

  // Inprogress
  OrderINprogress: "In Progress",

  // Update Operation Name
  Operation_Name_SIGNIN: "ORDER_SIGNIN",
  Operation_Name_UPDATE_UTN: "ORDER_UTN_UPDATE",
  Operation_Name_OVERRIDE: "ORDER_OVERRIDE",
  Operation_Name_APPROVE: "ORDER_APPROVE",
  Operation_Name_CANCEL: "ORDER_CANCEL",
  Operation_Name_REJECT: "ORDER_REJECT",

  // DC Cutoff count Data
  DC_CUTOFF_COUNT: "DC Cutoff Count",
  DC_CUTOFF_TIME: "DC Cutoff",
  DC_CUTOFF_ORDERS: "# of Orders",
  DC_CUTOFF_NOORDERS: "No Orders at this time",
};

export const CommonConstants = {
  BLANK: "",
  COMMA: ",",
  STR_ZERO: "0",
  STR_ONE: "1",
  ZERO: 0,
  ONE: 1,
  TWO: 2,
  SUCCESS: "success",
  APPROVED: "approved",
  PENDING: "pending",
  NEW: "new",
  LOCKED: "locked",
  SIGNED: "signed",
  SIGNED_NOT_SIGNED: "Your Order was not signed. Please Try Again.",
  SIGNED_ORDER_OPERATION: "ORDER_SIGNIN",
};
